import { Component } from '@angular/core';
import {RouterLinkActive} from "@angular/router";

@Component({
  selector: 'app-tabs',
  standalone: true,
    imports: [
        RouterLinkActive
    ],
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.scss'
})
export class TabsComponent {

}
